import { render, staticRenderFns } from "./AdminCalendarEvent.vue?vue&type=template&id=1df3634b&scoped=true&"
import script from "./AdminCalendarEvent.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminCalendarEvent.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3634b",
  null
  
)

export default component.exports